import { ISourceDataConfigurationFormField, ISourceDataConfigurationFormSection } from "@/api/dtos";
import { ConfigurationType, LinkedProperties } from "@/utilities/forms/ConfigurationFormProcessor";
import { type } from "os";
import { createSectionFields, ISelectionOption, IUpdateMapping, updateBySelection, updateField, updateValues } from ".";
import { ISourceDataConfigurationFormFieldValue, IFormFieldMetadata } from '../../../../../api/dtos';
import { CSharpTypeMapping } from './index';

export const ConfigurationUpdateSectionMapping: IUpdateMapping = {
    
    createOptions:  (source, target) => {
        let options: ISelectionOption[] = [
            {
                name: 'options',
                label: 'Options',
                options: [
                    {
                        name: 'overrideName',
                        label: 'Override Name',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormSection).name = (sourceValue as ISourceDataConfigurationFormSection).name;
                        }
                    },
                    {
                        name: 'priority',
                        label: 'Priority',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormSection).priority = (sourceValue as ISourceDataConfigurationFormSection).priority;
                        }
                    },
                    {
                        name: 'excludeBlank',
                        label: 'Hide Section When No Data Provided',
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            (newValue as ISourceDataConfigurationFormSection).excludeBlank = (sourceValue as ISourceDataConfigurationFormSection).excludeBlank;
                        }
                    },
                    {
                        name: 'collection',
                        label: 'Collection',
                        options: [
                            {
                                name: 'latestRepeat',
                                label: 'Latest Repeat Only',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).latestRepeat = (sourceValue as ISourceDataConfigurationFormSection).latestRepeat;
                                }
                            },
                            {
                                name: 'minimumRepeat',
                                label: 'Minimum Repeat',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).minimumRepeat = (sourceValue as ISourceDataConfigurationFormSection).minimumRepeat;
                                }
                            },
                            {
                                name: 'maximumRepeat',
                                label: 'Maximum Repeat',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).maximumRepeat = (sourceValue as ISourceDataConfigurationFormSection).maximumRepeat;
                                }
                            }
                        ]
                    },
                    {
                        name: 'alerts',
                        label: 'Alerts',
                        options: [
                            {
                                name: 'information',
                                label: 'Information',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).alertInformation = (sourceValue as ISourceDataConfigurationFormSection).alertInformation;
                                }
                            },
                            {
                                name: 'warning',
                                label: 'Warning',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).alertWarning = (sourceValue as ISourceDataConfigurationFormSection).alertWarning;
                                }
                            },
                            {
                                name: 'error',
                                label: 'Error',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).alertError = (sourceValue as ISourceDataConfigurationFormSection).alertError;
                                }
                            },
                            {
                                name: 'success',
                                label: 'Success',
                                update: (source, target, sourceValue, targetValue, newValue) => {
                                    (newValue as ISourceDataConfigurationFormSection).alertSuccess = (sourceValue as ISourceDataConfigurationFormSection).alertSuccess;
                                }
                            }
                        ]
                    }
                ]
            }
        ];

        if (source.formVersionMetadata?.fields && source.formVersionMetadata.fields.length !== 0) {
            const sectionFieldMetadata = source.formVersionMetadata.fields.filter(x => x.formSectionMetadataId === source.formSectionKey);

            if (sectionFieldMetadata.length !== 0) {
                options.push({
                    name: 'fields',
                    label: 'Fields',
                    options: sectionFieldMetadata.map(x => ({
                        name: x.id!,
                        label: `${x.name}`,
                        update: (source, target, sourceValue, targetValue, newValue) => {
                            const typedNewValue = (newValue as ISourceDataConfigurationFormSection);
                            const typedTargetValue = (targetValue as ISourceDataConfigurationFormSection);
                            const typedSourceValue = (sourceValue as ISourceDataConfigurationFormSection);
                            
                            if (!typedNewValue.linked) {
                                createSectionFields(typedSourceValue, typedTargetValue, typedNewValue, target.formSectionMetadata, target.formVersionMetadata)
                            }


                            updateField(typedSourceValue, typedTargetValue, typedNewValue, x.id!, target.formVersionMetadata);
                        }
                    }))
                });
            }
        }

        return options;
    },
    update: (source, target, sourceValue, targetValue, options, selection) => {
        const newValue = { 
            ...targetValue,
            linked: sourceValue.linked
        };

        updateBySelection(source, target, sourceValue, targetValue, newValue, options, selection);

        return newValue;
    }
}